import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

// Horseshoe3D + Cylinder — architectural latticed columns
export const example32 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'deluksic',
    name: 'Horseshoe3D + Cylinder',
    description: 'architectural latticed columns',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -3,
    skipIters: 15,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitSphere',
    vibrancy: 0.5,
    contrast: 1,
    gamma: 2.2,
    depthColorPower: 0,
    lightDirection: [-0.5, 0.5, -1],
    lightPower: 0,
    highlightPower: 0.5,
    densityEstimationQuality: 0.8,
    estimatorCurve: 0.5,
    paletteMode: 0,
    palettePhase: 0,
    paletteSpeed: 0.5,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 0.5,
      phi: 1.4,
      radius: 0.24895426440887408,
      target: [0, 0, 0],
      fov: 60,
    },
  },
  transforms: {
    [tid('3d_lattice_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.9,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.9,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.9,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.2, y: 0.1 },
      variations: {
        [vid('3d_lattice_a_v0')]: { type: 'horseshoe3D', weight: 1 },
      },
    },
    [tid('3d_lattice_b')]: {
      probability: 0.35,
      preAffine: {
        a: 0.7,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.7,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.15, y: 0.3 },
      variations: {
        [vid('3d_lattice_b_v0')]: { type: 'cylinder3D', weight: 0.7 },
        [vid('3d_lattice_b_v1')]: { type: 'swirl3D', weight: 0.3 },
      },
    },
    [tid('3d_lattice_c')]: {
      probability: 0.25,
      preAffine: {
        a: 0.5,
        b: 0.2,
        c: 0,
        d: 0,
        e: -0.2,
        f: 0.5,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.4, y: -0.1 },
      variations: {
        [vid('3d_lattice_c_v0')]: { type: 'horseshoe3D', weight: 0.5 },
        [vid('3d_lattice_c_v1')]: { type: 'sinusoidal3D', weight: 0.5 },
      },
    },
  },
  finalTransform: {
    a: 1,
    b: 0,
    c: 0,
    d: 0,
    e: 0,
    f: 1,
    g: 0,
    h: 0,
    i: 0,
    j: 0,
    k: 1,
    l: 0,
  },
})
